import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Typography, 
  Container, 
  IconButton, 
  Box,
  Divider,
  Paper
} from '@mui/material';
import { Close } from '@mui/icons-material';

const Documentation = ({ open, onClose }) => {
    return (
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="md" 
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4" color="#0d9488">
              Documentation
            </Typography>
            <IconButton onClick={onClose} aria-label="close">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent dividers>
          <Container>
            <Typography variant="h6" gutterBottom>
              Getting Started
            </Typography>
            <Typography paragraph>
              Welcome to the Searcheble documentation. This guide will help you set up and use our platform efficiently.
            </Typography>
            
            <Paper elevation={0} sx={{ bgcolor: '#f5f5f5', p: 2, mb: 3, borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom color="primary">
                Quick Start
              </Typography>
              <Typography variant="body2">
                To quickly get started with Searcheble, follow these steps:
                1. Create an account
                2. Set up your first index
                3. Connect your data source
                4. Start searching!
              </Typography>
            </Paper>
  
            <Divider sx={{ my: 3 }} />
  
            <Typography variant="h6" gutterBottom>
              API Reference
            </Typography>
            <Typography paragraph>
              Our RESTful API allows you to integrate Searcheble's powerful search capabilities directly into your applications.
            </Typography>
            
            <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
              Authentication
            </Typography>
            <Typography paragraph>
              All API requests require authentication using API keys. You can generate and manage your API keys from your account dashboard.
            </Typography>
            
            <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
              Endpoints
            </Typography>
            <Typography paragraph>
              The base URL for all API requests is <code>https://api.searcheble.com/v1</code>
            </Typography>
            
            <Divider sx={{ my: 3 }} />
            
            <Typography variant="h6" gutterBottom>
              SDK Documentation
            </Typography>
            <Typography paragraph>
              We provide SDKs for various programming languages to make integration even easier:
            </Typography>
            <Typography component="ul" gutterBottom>
              <li>JavaScript/TypeScript</li>
              <li>Python</li>
              <li>Ruby</li>
              <li>PHP</li>
              <li>Java</li>
            </Typography>
  
            <Typography paragraph sx={{ mt: 4, fontStyle: 'italic' }}>
              For more detailed documentation, code examples, and tutorials, please visit our developer portal.
            </Typography>
          </Container>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default Documentation;